import type { Company } from "@prisma/client";

export default function directionsUrl(
  company: Pick<Company, "name" | "city" | "address" | "zipCode">,
): string {
  const { name, city, address, zipCode } = company;
  const baseUrl = "https://www.google.com/maps/search/";

  return `${baseUrl}?api=1&query=${name}, ${address}, ${zipCode} ${city}`;
}
